 const isoLanguageCodes: Record<string, string> = {
    'fr-ca': 'Français',
    'en-ca': 'English'
};
 
export default isoLanguageCodes;